import {Component, OnInit, ViewChild} from '@angular/core';
import {CatoService} from '../../../services/cato.service';
import {PageDTO} from '../../../../../common/dtos/PageDTO';
import {Cato} from './cato';
import {LangChange} from '../../../../../lang-change';
import {TranslateService} from '@ngx-translate/core';
import {Language} from '../../../../../common/models/language';
import {PaginationComponent} from '../../../../shared/components/pagination/pagination.component';
import {Utils} from '../../../../../common/services/Utils';
import {Principal} from "../../../../../common/services/principal";

@Component({
  selector: 'app-catos',
  templateUrl: './cato.component.html',
  styleUrls: ['./cato.component.scss']
})
export class CatoComponent extends LangChange implements OnInit {

  searchText = '';
  page: PageDTO;
  totalElements = 0;
  catoList: Cato[];
  langID: number;
  isAdmin: boolean = false;

  @ViewChild(PaginationComponent) child;

  constructor(private _catoService: CatoService,
              private _utils: Utils,
              private translateService: TranslateService,
              private principal: Principal) {
    super(translateService);
    this.langID = Language.getCurrentLanguage().id;
    this.isAdmin = this.principal.isAdmin();
  }

  ngOnInit() {
    this.page = new PageDTO();
    this.page.sorting = {};
    this.page.filter = {
      searchText: ''
    };
    this.load();
  }

  reloadBySort(p, v) {
    const field = p.toLowerCase().includes('name') ? this._utils.getLangSuff(p) : p;
    if (!v && this.page.sorting[field]) {
      delete this.page.sorting[field];
    }
    if (v) {
      this.page.sorting[field] = v;
    }
    this.load();
  }

  load() {
    this._catoService.getDictionaries(this.page, this.langID).subscribe(
      response => {
        this.catoList = response.dtoList;
        this.totalElements = response.totalElements;
        this.changeCatoListLanguage();
        if (this.page.pageNumber === 0 && this.child) {
          this.child.getPager();
        }
      }
    );
  }

  changeCatoListLanguage() {
    if (this.catoList) {
      if (this.langID === Language.RUSSIAN.id) {
        for (let i = 0; i < this.catoList.length; i++) {
          this.catoList[i].name = this.catoList[i].nameRu;
          this.catoList[i].region.name = this.catoList[i].region.nameRu;
          this.catoList[i].shortName = this.catoList[i].shortNameRu;
        }
      } else {
        for (let i = 0; i < this.catoList.length; i++) {
          this.catoList[i].name = this.catoList[i].nameKz;
          this.catoList[i].region.name = this.catoList[i].region.nameKz;
          this.catoList[i].shortName = this.catoList[i].shortNameKz;
        }
      }
    }
  }

  onLangChange(langCode): void {
    this.langID = langCode.id;
    this.changeCatoListLanguage();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/user/components/dictionary/cato/cato.component.ts